

export enum IndeedBudgetFirstMonthBehavior {
    StartNowProratedAmount = 1,
    StartNowFullAmount = 2,
    StartNextMonthFullAmount = 3
}